import Reveal from "./Reveal";

export default function CustomWeb({ t, waLink }) {
  const c = t.custom;
  return (
    <section id="custom" className="py-20 md:py-24 border-t border-[var(--border)] bg-[#080808]">
      <div className="container-x grid grid-cols-12 gap-8 md:gap-12 items-center">
        <div className="col-span-12 md:col-span-6">
          <Reveal>
            <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)] font-display">
              <span className="w-6 h-[1px] bg-[var(--accent)]" />
              {c.overline}
            </div>
          </Reveal>
          <Reveal delay={0.05} y={30}>
            <h3 className="mt-5 font-display font-black uppercase leading-[1] tracking-tighter text-4xl md:text-5xl lg:text-6xl text-[var(--text)]">
              {c.title.split(" ").slice(0, -2).join(" ")}{" "}
              <span className="font-serif-italic text-[var(--accent)] font-normal normal-case">
                {c.title.split(" ").slice(-2).join(" ")}
              </span>
            </h3>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 text-[var(--text-muted)] text-base md:text-lg leading-relaxed max-w-lg">
              {c.body}
            </p>
          </Reveal>
          <Reveal delay={0.22}>
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="custom-cta"
              className="btn-ghost mt-8"
            >
              {c.cta} <span aria-hidden>→</span>
            </a>
          </Reveal>
        </div>

        <div className="col-span-12 md:col-span-6">
          <Reveal delay={0.1}>
            <div className="flex flex-wrap gap-3">
              {c.tags.map((tag, i) => (
                <div
                  key={i}
                  className="border border-[var(--border)] rounded-full px-5 py-3 text-sm text-[var(--text)] font-display uppercase tracking-widest hover:border-[var(--accent)] hover:text-[var(--accent)] transition-colors cursor-default"
                  data-testid={`custom-tag-${i}`}
                >
                  <span className="text-[var(--text-muted)] mr-2 font-serif-italic normal-case">
                    0{i + 1}
                  </span>
                  {tag}
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
